<template>
  <b-card>
    <div class="flex justify-end mb-[16px]">
      <b-button
        variant="primary"
        :disabled="!blob"
        @click="downloadExcel"
      >
        Download Report
      </b-button>
    </div>

    <b-overlay :show="loading">
      <div
        v-if="htmlPreview"
        class="overflow-auto [&_*]:whitespace-nowrap [&_table]:w-full [&_table]:border-collapse [&_td]:border [&_td]:min-w-full [&_td]:p-[8px] [&_th]:border [&_th]:min-w-full [&_th]:p-[8px]"
        v-html="htmlPreview"
      />
      <div
        v-else-if="!loading"
        class="text-center py-10"
      >
        Gagal memuat preview.
      </div>
    </b-overlay>
  </b-card>
</template>

<script>
import * as XLSX from 'xlsx'
import { komtimAxiosIns } from '@/libs/axios'

export default {
  data() {
    return {
      loading: false,
      htmlPreview: '',
      blob: null,
    }
  },
  mounted() {
    this.fetchBinaryData()
  },
  methods: {
    async fetchBinaryData() {
      this.loading = true
      try {
        const { data } = await komtimAxiosIns.get(`v1/admin_marketplace_performance/report/${this.$route.params.id}/download`, {
          responseType: 'arraybuffer',
        })

        this.blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const workbook = XLSX.read(data, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]

        this.htmlPreview = XLSX.utils.sheet_to_html(worksheet)
      } catch (error) {
        this.alertError(error)
      } finally {
        this.loading = false
      }
    },
    downloadExcel() {
      const url = window.URL.createObjectURL(this.blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `report-admin-marketplace-${this.$route.params.id}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
  },
}
</script>

<style scoped>
.sheet >>> table {
  width: 100%;
  border-collapse: collapse;
}
.sheet >>> td, .sheet >>> th {
  border: 1px solid #ddd;
  padding: 8px;
  min-width: 100px;
}
</style>
